<template lang="html">
  <div
    v-tracking-context="{ event_element: 'search_input' }"
    class="search js-search"
  >
    <form
      class="header-search js-search-input"
      :action="searchMappingPath"
      method="post"
      @submit.prevent="onSubmit"
    >
      <div
        class="header-search__outer js-search-input__focus-scroll-anchor--fused"
      >
        <div
          class="header-search__input search-input js-search-input__wrapper"
          :data-skip-manual-track="true"
          data-overflow-left="search-input--overflow-left"
          data-overflow-right="search-input--overflow-right"
          data-selected-pill="search-input__pill--selected"
        >
          <div class="search-input__inner js-search-input__inner">
            <div class="search-input__pills js-search-input__pills" />
            <input
              ref="input__hidden"
              type="hidden"
              name="qm[]"
              class="js-search-input__hidden"
            />
            <input
              id="js-typeahead"
              ref="input"
              class="search-input__input js-search-input__input"
              type="text"
              :data-typeahead-url="typeAheadUrl"
              :data-split-spaces="splitSpaces"
              :data-job-market="jobMarket"
              :placeholder="'client.fused.search.placeholder' | t"
            />
          </div>
        </div>
        <button
          class="button button--large button--primary header-search__button"
        >
          {{ buttonText | t }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { manualTrack } from '@/vue/directives/tracking'

export default {
  computed: {
    ...mapState([
      'searchMappingPath',
      'typeAheadUrl',
      'jobMarket',
      'splitSpaces'
    ]),
    ...mapGetters(['isSearchProfileEmpty']),
    buttonText() {
      return this.isSearchProfileEmpty
        ? 'client.fused.search.new'
        : 'client.fused.search.edit'
    }
  },
  mounted() {
    this.$VueEventBus.on(
      'search__headerSearchButton--nonStickyClicked',
      this.focusSearchInput
    )
  },
  destroyed() {
    this.$VueEventBus.off(
      'search__headerSearchButton--nonStickyClicked',
      this.focusSearchInput
    )
  },
  methods: {
    ...mapActions(['mapSearch']),
    onSubmit(event) {
      const target = event.currentTarget
      // Unfortunately we need to wait on the legacy js code to update the input field
      // TODO: Remove this when the search box is rewritten in Vue.
      setTimeout(() => {
        const search = this.$refs.input__hidden.value || ''
        manualTrack(target, {
          event_element: 'search_input',
          action_type: `search_${this.isSearchProfileEmpty ? 'new' : 'change'}`,
          target: search
        })
        this.mapSearch(search).then(() => {
          EventBus.trigger('search:reset', null)
        })
      })
    },
    focusSearchInput() {
      this.$refs.input.focus()
    }
  }
}
</script>
